import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Step 1: Define the type for consumer ID
interface CunsumerId {
  id: number;
}

// Step 2: Define the slice state type
interface CunsumerState {
  cunsumerOfferId: CunsumerId | null;
}

// Step 3: Set the initial state
const initialState: CunsumerState = {
  cunsumerOfferId: null,
};

// Step 4: Create the slice
const CunsumerSlice = createSlice({
  name: 'CunsumerOfferId',
  initialState,
  reducers: {
    SetCunsumerId: (state, action: PayloadAction<CunsumerId | null>) => {
      state.cunsumerOfferId = action.payload;
    },
  },
});

export const { SetCunsumerId } = CunsumerSlice.actions;
export default CunsumerSlice.reducer;
